import { render, staticRenderFns } from "./BotaoVoltar.vue?vue&type=template&id=1aab2e00&scoped=true"
import script from "./BotaoVoltar.vue?vue&type=script&lang=js"
export * from "./BotaoVoltar.vue?vue&type=script&lang=js"
import style0 from "./BotaoVoltar.vue?vue&type=style&index=0&id=1aab2e00&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab2e00",
  null
  
)

export default component.exports